<template>
  <div class="projects-page" :class="{
    'is-works-page': isWorksPage,
  }">
    <div class="projects grid-x">
      <div class="filters small-12 large-6 large-offset-3">
        <p class="h5">
          <span
            data-hover="link"
            @click="clickCat(cat)"
            v-for="(cat) in categories"
            :key="cat.value"
            :class="{'active' : cat.active}"
          >{{$t('filters.' + cat.value)}}</span>
        </p>
      </div>
    </div>
    <transition name="works-change" mode="out-in">
      <div class="projects grid-x grid-margin-x align-top" :key="JSON.stringify(activeCats)">
        <work
          @mouseenter.native="hover = work._id"
          @mouseleave.native="hover = null"
          class="work-item"
          v-bind:data-cat="work.type"
          v-for="(work) of works"
          :key="work._id"
          :work="work"
          v-show="isVisible(work)"
          :class="hover !== null && hover !== work._id ? 'not-hovered' : ''"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import Work from "../single/Work";
import { mapGetters } from "vuex";

export default {
  components: {
    Work
  },
  data() {
    return {
      activeProject: false,
      hover: null,
      activeCats: [],
      categories: [
        {
          value: "show-case",
          text: "Show Case",
          active: false
        },
        // {
        //   value: "research",
        //   text: "Research",
        //   active: false
        // },
        {
          value: "client",
          text: "Client",
          active: false
        }
      ]
    };
  },
  mounted() {
    this.getWorks();
    var exist = false;
    // Esiste la query con le categorie?
    if (this.$route.query.cat) {
      // Prendo la query e la splitto in un array
      var query = this.$route.query.cat.split(",");
      // Controllo che almeno un elemento della query sia una categoria esistente
      exist = !!this.categories.find(cat => {
        return query.indexOf(cat.value) >= 0;
      });
      // Se esiste
      if (exist) {
        this.categories = this.categories.map(cat => {
          cat.active = query.indexOf(cat.value) >= 0;
          return cat;
        });
      }
    }
    // Se non esiste la query o se non ci sono categorie esistenti nella query
    if (!exist) {
      this.categories.map(item => {
        item.active = true;
      });
    }
    if (this.$route.query && this.$route.query.filter) {
      this.activeFilter = this.$route.query.filter
      this.clickCat({
        active: true,
        text: this.$route.query.filter === 'show-case' ? 'Show Case' : 'Client',
        value: this.$route.query.filter
      })
    }
    this.elaborateCats();
  },
  beforeRouteUpdate(to, from, next) {
    this.getWorks();
    next();
  },
  computed: {
    ...mapGetters({
      works: "getWorks"
    }),
    shownWorks() {
      return this.works.map((item, index) => {
        let category = this.categories.filter(cat => {
          return cat.value === item.type;
        });
        if (category[0] && category[0].active) {
          return item;
        }
        return false;
      });
    },
    isWorksPage() {
      return this.$route.name === "cosa";
    }
  },
  methods: {
    isVisible(work) {
      let category = this.categories.filter(cat => {
        return cat.value === work.type;
      });
      if (category[0] && category[0].active) {
        return true;
      }
      return false;
    },
    getWorks() {
      this.$store.dispatch("getWorks", '?limit=100000');
    },
    clickCat(cat) {
      if (
        this.categories.filter(cat => {
          return cat.active;
        }).length === this.categories.length
      ) {
        this.categories.map((item, index) => {
          if (item.value !== cat.value) {
            item.active = false;
          }
        });
      } else {
        cat.active = !cat.active;
      }

      if (
        !this.categories.filter(cat => {
          return cat.active;
        }).length
      ) {
        this.categories.map((item, index) => {
          item.active = true;
        });
      }
      this.elaborateCats();
    },
    elaborateCats() {
      this.activeCats = [];
      this.categories.map(cat => {
        if (cat.active) {
          this.activeCats.push(cat);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@assets/scss/_importer.scss";

.works-change-enter-active,
.works-change-leave-active {
  transition: all 0.4s;
  -o-transition: all 0.4s;
  -moz-transition: all 0.4s;
  -webkit-transition: all 0.4s;
}

.works-change-enter,
.works-change-leave-to {
  opacity: 0;
}
.works-change-enter-to,
.works-change-leave {
  opacity: 1;
}

.projects-page {
  position: relative;
  padding: 64px;
  @include breakpoint(medium down) {
    padding: 0 0 64px;
  }
  &::before {
    content: "";
    position: absolute;
    top: -64px;
    left: -64px;
    background: $light-gray;
    height: calc(100% + 64px);
    width: calc(100% + 128px);
    z-index: -1;
  }
  &.is-works-page {
    &::before {
      @include breakpoint(medium down) {
        left: 0;
        width: 100%;
      }
    }
  }
  &:not(.is-works-page) {
    &::before {
      left: -64px;
      top: -32px;
      height: calc(100% + 64px);
      width: calc(100% + 128px);
      @include breakpoint(medium down) {
        left: -32px;
        width: calc(100% + 64px);
      }
    }
  }
}

.projects {
  .filters {
    padding-top: 128px;
    padding-bottom: 64px;
    @include breakpoint(medium down) {
      padding: 64px 32px;
    }
    @include breakpoint(large up) {
      padding-top: 64px;
    }

    @include breakpoint(medium down) {
      width: 100%;
    }
    p {
      font-weight: $global-weight-bold;
      line-height: 20px;
      span {
        display: inline-block;
        margin-right: 16px;
        &:last-of-type {
          margin-right: 0;
        }
        color: $dark-gray;
        cursor: pointer;
        &.active {
          color: $black;
          text-decoration: underline;
          &:hover {
            text-decoration: none;
          }
        }
      }
    }
  }
  .work-item:not(.works-enter-active) {
    &:not(.works-leave-active) {
      &:not(.works-move) {
        @include transition-duration();
        &.not-hovered {
          opacity: 0.75;
        }
      }
    }
  }
}
</style>
